import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingService } from '../../core/loading/loading.service';
import { ExcelExportService } from './excel-export.service';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'pgs-excel-export',
  templateUrl: './excel-export.component.html',
  styleUrls: ['./excel-export.component.scss'],
})
export class ExcelExportComponent {

  @Input() data: { [sheetName: string]: any } | (() => Observable<{ [sheetName: string]: any }>);
  @Input() fileName = 'sample';
  @Input() className: string;

  constructor(private excelService: ExcelExportService,
              private loadingService: LoadingService) {
  }

  export(): void {
    if (typeof this.data === 'function') {
      this.loadingService.show('Exportando reporte');
      (this.data as any)().pipe(
        finalize(() => this.loadingService.hide())
      ).subscribe(data => {
          if (data.value) {
            this._export(data.value);
          } else {
            this._export(data);
          }
        }
      );
    } else if (this.data) {
      this._export(this.data);
    }
  }
  
  private _export(data: any): void {
    if (data instanceof Observable) {
      data.subscribe(obj => this.exportAsExcelInOneSheet(obj));
    } else {
      this.exportAsExcelInOneSheet(data);
    }
  }

  private exportAsExcelInOneSheet(data: any): void {
    const newDataObject = Object.assign({ }, data);
    delete newDataObject.documentTitle;
    this.excelService.exportAsExcelInOneSheet(newDataObject, this.fileName, data.documentTitle);
  }
}
